import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function CreatedDate(props: any) {
    const {selectedFilters, handleChange, placeholder} = props
    const [isFocused, setIsFocused] = useState(false);
    const yesterday = new Date();

    const selectedDate = selectedFilters?.created_on ? new Date(selectedFilters.created_on): null;
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
        <div className={`datepicker ${shouldShowLabel ? 'date-lable' : ''}`}>
            <label>{placeholder}</label>
            <DatePicker
                selected={selectedDate}
                onChange={(date) => handleChange(date, 'created_on')}
                showMonthDropdown
                showYearDropdown
                maxDate={yesterday}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                dateFormat="yyyy-MM-dd"
            />
        </div>
    );
}

function StartDate(props: any) {
    const {selectedFilters, handleChange, maxDate, placeholder} = props
    const [isFocused, setIsFocused] = useState(false);

    const selectedDate = selectedFilters?.start_date ? new Date(selectedFilters.start_date): null;
    const shouldShowLabel = !!selectedDate || isFocused;

    return (
         <div className={`datepicker ${shouldShowLabel ? 'date-lable' : ''}`}>
            <label>{placeholder}</label>
            <DatePicker
                selected={selectedDate}
                onChange={(date) => handleChange(date, 'start_date')}
                showMonthDropdown
                showYearDropdown
                maxDate={maxDate || null}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                dateFormat="yyyy-MM-dd"
            />
        </div>
    );
}

export { CreatedDate, StartDate}
